<template>
	<MainLayout>
		<div class="container-sm">
			<b-card class="rounded">
				<b-card-body>
					<h4>{{$t('accessDenied.accessDenied')}}</h4>
					<p class="text-muted">{{$t('accessDenied.expiredAccess')}}</p>

					<!-- selects view -->
					<b-form v-if="countAll >= 10" @submit="doChangePlatform">
						<div class="bg-light p-4 rounded">
							<b-form-group label-size="sm" label-class="text-muted" :label="$t('global.selectOption')" class="mb-3">
								<b-form-select v-model="systemSelected" @change="fillSelect($event)" class="mt-2">
									<b-form-select-option :value="null" disabled>{{$t('global.selectOption')}}</b-form-select-option>
									<b-form-select-option v-if="loadSuppliers" value="supplier">{{$t('global.supplier')}}</b-form-select-option>
									<b-form-select-option v-if="loadPos" value="pos">{{$t('global.pointOfSale')}}</b-form-select-option>
								</b-form-select>
							</b-form-group>

							<b-form-group label-size="sm" label-class="text-muted" :label="systemSelectedMsg" class="mb-4">
								<b-form-select v-model="sassReferenceId" :options="sassOpts" class="mt-2" required/>
							</b-form-group>

							<div class="text-center">
								<b-button variant="primary" block type="submit">{{ $t('global.change') }}</b-button>
							</div>
						</div>
					</b-form>

					<!-- buttons view -->
					<b-row v-if="countAll > 1 && countAll < 10" class="pb-3">
						<!-- pos -->
						<b-col v-if="loadPos && Object.keys(pos).length > 0" md="6">
							<div class="bg-light p-4 rounded">
								<h5>{{$t('global.pointOfSale')}}</h5>

								<b-button
									v-for="(item,i) in pos"
									:key="i"
									variant="info"
									class="mr-2 my-1"
									size="sm"
									v-b-tooltip.hover v-b-tooltip.placement.auto
									:title="$t('global.clicToSwitch') + ' ' + $t('global.pointOfSale')"
									@click="goToPlatform('pos', item.value)"
								>
									{{ item.text }}
								</b-button>
							</div>
						</b-col>

						<!-- suppliers -->
						<b-col md="6" v-if="loadSuppliers">
							<div class="bg-light p-4 rounded">
								<h4>{{$t('global.supplier')}}</h4>
								<b-button
									v-for="(item,i) in $root.auxVars.userSuppliersAccess"
									:key="i"
									variant="warning"
									class="mr-2 my-1"
									size="sm"
									v-b-tooltip.hover v-b-tooltip.placement.auto
									:title="$t('global.clicToSwitch') + ' ' + $t('global.supplier')"
									@click="goToPlatform('supplier', item.value)"
								>
									{{ item.text }}
								</b-button>
							</div>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from "../sections/layout/MainLayout.vue";
import chatProvider from "@/components/helpers/helpers-chat";
export default {
	components: { MainLayout },
	data() {
		return {
			sassReferenceId: null,
			systemSelected: null,
			sassOpts: [],
			pos: [],
			systemSelectedMsg: this.$t('global.changeOf', {system: ''}),
		}
	},
	methods: {
		// logic --
		fillSelect() {
			if (this.systemSelected === 'supplier') {
				this.systemSelectedMsg = this.$t('global.changeOf', {system: this.$t('global.supplier')})
				this.sassOpts = this.$root.auxVars.userSuppliersAccess
			} else if (this.systemSelected === 'pos') {
				this.systemSelectedMsg = this.$t('global.changeOf', {system: this.$t('global.pointOfSale')})
				this.sassOpts = this.$root.auxVars.userPointOfSalesAccess.filter(item => item.value !== this.$root.store.state.currentSystem.system.id)
			}
		},

		_process(type, referenceId) {
			this.$root.showWarning({
				message: this.$t('warnings.switchSystem'),
				okAction: (event, setLoading, close) => {
					setLoading(true)

					switch (type) {
						case 'pos':
							this.$root.api.post('/auth/system', null, {
								headers: {
									"X-SC-TYPE": 'pos',
									"X-SC-SYSTEM": referenceId,
								}
							}).then((response) => {
								this.$root.store.setSystemData(response.data)

								if(this.$route.path === '/')
									location.reload()
								else
									this.$router.push('/')

								setLoading(false)
							}).catch((err) => {
								this.$root.handleRequestError(err)
								close()
							})
							break;
						case 'supplier':
							window.location = process.env.VUE_APP_SUPPLIERS + '/login?referenceId=' + referenceId + '&token=' + this.$root.store.state.currentToken
							setLoading(false)
							this.$root.auxVars.clearResources();
							this.$root.store.clearUser();
							if (this.$root.chatStarted) {
								chatProvider.shutdown()
								this.$root.chatStarted = false;
							}
							break;
						default:
							this.$root.showAlert(this.$t('warnings.selectValidSystem'), {variant: 'danger'})
							break;
					}
				}
			})
		},

		posOpts() {
			this.pos = this.$root.auxVars.userPointOfSalesAccess.filter(item => item.value !== this.$root.store.state.currentSystem.system.id)
		},

		// event for select view
		doChangePlatform(evt) {
			evt.preventDefault();
			this._process(this.systemSelected, this.sassReferenceId)
		},

		// event for btns view
		goToPlatform(type, reference) {
			this._process(type, reference)
		}
	},
	mounted() {
		this.posOpts()
	},
	computed: {
		resource() {
			return this.$root.auxVars.userPointOfSalesAccess
		},
		countAll() {
			let pos = this.$root.auxVars.userPointOfSalesAccess
			let sup = this.$root.auxVars.userSuppliersAccess

			let total = 0
			if(typeof sup != 'undefined')
				total = parseInt(pos.length) + parseInt(sup.length)
			else
				total = parseInt(pos.length)

			return total;
		},
		loadSuppliers() {
			return typeof this.$root.auxVars.userSuppliersAccess != 'undefined';
		},
		loadPos() {
			return typeof this.$root.auxVars.userPointOfSalesAccess != 'undefined';
		}
	},
	watch: {
		resource() {
			this.posOpts()
		}
	}
}
</script>



















